import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';

import { FormHelper } from '../../helpers/form-helper';
import { Member } from '../../models/member';
import { MemberService } from '../../services/member.service';

@Component({
  selector: 'app-add-member',
  templateUrl: './add-member.component.html',
  styleUrls: ['./add-member.component.scss']
})
export class AddMemberComponent extends FormHelper implements OnInit {

  constructor(private dialogRef: MdDialogRef<AddMemberComponent>,
							private formBuilder: FormBuilder,
							private memberService: MemberService) {
		super();

		this.buildForm();
	}

  ngOnInit() {
	}

	public buildForm(): void {
		this.form = this.formBuilder.group({
			name: new FormControl('', Validators.required),
			lastname: new FormControl('', Validators.required),
			phone: new FormControl('', Validators.required),
			email: new FormControl('', Validators.required)
		});
	}

	public submitForm(): void {
		let member: Member = this.form.value;

		this.memberService.addMember(member);

		this.dialogRef.close();
	}

}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/add-member/add-member.component.ts